import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Input,
  Output,
  ElementRef,
} from "@angular/core";
import { PatientD } from '../../models/Pdetails';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Checkin } from 'src/app/models/scheckin';
declare var $: any;
declare var angular: any;
import { Location } from '@angular/common';
import { Utils } from 'src/app/common/utils';
import { AllPatient } from "src/app/models/patient";

import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  UntypedFormArray,
} from "@angular/forms";
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { any } from "underscore";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: 'app-patient-details',
  templateUrl: './patient-details.component.html',
  styleUrls: ['./patient-details.component.css']
})
export class PatientDetailsComponent implements OnInit {
  @ViewChild('PDFModal', { static: true } as any) PDFModal: TemplateRef<any>;
  patientd = [];

  @ViewChild("inputFile")
  // patientd = new PatientD();


  p_address_1: any;
  p_address_2: any;
  p_city_n: any;
  p_contact_no: any;
  p_dob: any;
  p_email_id: any;
  p_first_name: any;
  p_gender: any;
  p_last_name: any;
  p_ppurl: any;
  p_state: any;
  p_zip: any;


  inputFile: ElementRef;
  pat: string;
  aid: any;
  cid: any;
  data: any;
  submitted: boolean;
  checkin = new Checkin();
  message: string;
  testsList: any[];
  modalForm: any;
  report_attachments: UntypedFormArray;
  selectedLabTest = null;
  closeResult: string;
  reportsToBeUploaded: any = [];
  fileExtension: any = [];
  apdate: Date;
  since: Date;
  followup_date: Date;

  details: any;

  forms = {
    documentsForm: null,
    patstats: null,
    reasonForm: null,
  };

  forms_stats = {
    documentsForm_stats: null,
  };

  statslist: any = [];
  pat_stats: UntypedFormArray;

  documents: UntypedFormArray;
  disableSubmit: boolean = false;

  uploadedFiles: [File]
  pid: any;
  mail: any;
  drid: any;
  pdfSrc: any;
  maxSize = Utils.MAX_FILE_SIZE;
  reason: any;
  pids: any;
  reasonForm: UntypedFormGroup;
  pdfSrc1: any;
  p_purl: string;
  p_pre_followdate: string;
  p_pre_consultdate: string;
  dr_id: number;
  allergy: any;
  patient: AllPatient;
  endtime: any;
  online_checkin: any;
  aptime: any;
  consult_minutes: number;
  aptdate: Date;
  linksent = false;

  constructor(
    private location: Location,
    private modalService: NgbModal,
    private modal: NgbModal,
    private spinner: NgxSpinnerService,
    private service: VproService,
    private addPService: VproService,//new
    private fb: UntypedFormBuilder,//new
    private patService: VproService,
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private checkinService: VproService) {

    // this.forms_stats.documentsForm_stats = this._formBuilder.group({
    //   documents: this._formBuilder.array([]),
    // });

    this.forms.documentsForm = this._formBuilder.group({
      documents: this._formBuilder.array([]),
    });

    this.forms.patstats = this.fb.group({
      pat_stats: this.fb.array([]),
    });

    this.forms.reasonForm = this._formBuilder.group({
      reasons: [""],
    });

    this.modalForm = this._formBuilder.group({
      remarks: [""],
      review: [""],
      testid: [""],
      tstat: [""],
      report_attachments: this._formBuilder.array([]),
    });
  }

  ngOnInit() {
    this.cid = this.route.snapshot.params['cid'];
    this.aid = this.route.snapshot.params['cid'];
    this.drid = JSON.parse(localStorage.getItem('uid'))
    this.getStatsList(); //new
    this.getpat();

    // this.fetchPreviousLabReports();
  }
  //NEW

  // public submitreasonForm(values) {
  //   this.reason = values;

  // }

  public createRoom() {

    this.patService.getpat(this.cid).subscribe(data => {
      var leng = data.length;
      this.patientd = data;

      let body = {
        aid: this.cid,
        drid: this.dr_id,
        pid: this.pid,
        startDate: this.aptdate,
        aptime: this.aptime,
      }
      console.log("tbodybody", body);
      this.spinner.show();
      this.service
        .createroomforinperson(body)
        .subscribe(
          (res) => {
            this.linksent = true;
            this.spinner.hide();
            this.showToast("success", res.message);
          },
          (error) => {
            console.log(error);
            this.spinner.hide();
            let message;
            if (
              error &&
              error.error &&
              error.error.message &&
              error.error.message.message
            ) {
              message = error.error.message.message;
            } else if (error && error.error && error.error.message) {
              message = error.error.message;
            } else message = "Something went wrong. Please try again.";
            this.showToast("error", message);
          }
        );


    });


  }

  public getStatsLabel(i) {
    return this.statslist[i].stats_name;
  }


  public getStatsuom(i) {
    return this.statslist[i].stats_std_uom;
  }

  getStatsList() {
    this.spinner.show();
    this.addPService.getstatList().subscribe(
      (res) => {
        this.statslist = res;
        for (let stats of this.statslist) {
          this.pat_stats = this.forms.patstats.get(
            "pat_stats"
          ) as UntypedFormArray;
          this.pat_stats.push(this.addStats(stats.id));
        }
      },
      (error) => { }
    );
  }

  addStats(id): UntypedFormGroup {
    return this.fb.group({
      stats_id: [id],
      stats_value: [null],
    });
  }

  fetchPreviousLabReports(pidd, dr_id) {
    this.spinner.show();
    this.patService
      .fetchPatientTestsByPhysician({ pid: pidd, drid: dr_id })
      .subscribe((result) => {
        this.spinner.hide();
        this.testsList = result.reverse();
        let fileName, filen;
        for (var i = 0; i < this.testsList.length; i++) {
          filen = this.testsList[i].attachments;
          if (filen) {
            for (var j = 0; j < filen.length; j++) {
              var filenn = filen[j];
              if (filenn) {
                this.fileExtension.push(filen[j].split('?')[0].split('.').pop());
              }
            }
            this.testsList[i].attachments['ext'] = this.fileExtension;
            this.fileExtension = [];
          }
        }
      });
  }



  openEditLabTest(content, record) {
    this.modalForm.removeControl("report_attachments");
    this.modalForm.addControl(
      "report_attachments",
      this._formBuilder.array([])
    );
    this.report_attachments = this.modalForm.get(
      "report_attachments"
    ) as UntypedFormArray;

    if (record.attachments && record.attachments.length > 0) {
      record.attachments.forEach((attachment) => {
        this.report_attachments.push(
          this._formBuilder.group({
            s3Key: [attachment],
          })
        );
      });
    }
    this.modalForm.patchValue({
      testid: record.testid,
      review: record.review,
      remarks: record.remarks,
    });
    console.log(this.modalForm);
    this.selectedLabTest = record;
    this.modalService
      .open(content, { windowClass: "bloodTestModal" })
      .result.then(
        (result) => {
          this.selectedLabTest = null;
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.selectedLabTest = null;
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }


  uploadReports(files) {
    this.reportsToBeUploaded = [];
    if (files && files.length > 0) {

      Object.keys(files).forEach((key) => {
        if (key != "length") {
          this.reportsToBeUploaded.push(files[key]);
        }
      });
    }
    console.log("lllllllllllllllllllllllllllllll", this.reportsToBeUploaded);
  }

  updateLabTest(input) {
    input.tstat = "Captured";
    input.pid = this.pids
    console.log(input.pid);
    console.log("-----------------------------------------------")
    console.log(input);
    console.log(this.reportsToBeUploaded.length);
    if (this.reportsToBeUploaded.length == 0) {
      this.showToast('error', 'Choose file to upload');
      return null;
    }
    console.log(this.reportsToBeUploaded[0].name);
    input.org_code = localStorage.getItem("orgcode");
    input.attachments = this.reportsToBeUploaded.map((report) => {
      return { name: report.name, content_type: report.type };
    });
    input.existingKeys = input.report_attachments.map((item) =>
      item.s3Key.replace(`${environment.content_base_url}/`, "")
    );
    delete input.report_attachments;
    this.spinner.show();
    this.patService
      .updateLabtest(this.pids, input, this.reportsToBeUploaded)
      .subscribe(() => {
        this.spinner.hide();
        this.showToast('success', "Record updated successfully");
        this.reportsToBeUploaded = [];
        this.fetchPreviousLabReports(this.pids, this.dr_id);
      });
  }

  deleteAttachment(i) {
    this.report_attachments.removeAt(i);
  }

  getback() {
    this.location.back();
  }



  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }


  getpat() {
    this.patService.getpat(this.cid).subscribe(data => {
      var leng = data.length;
      console.log("LENGTH", leng);
      this.patientd = data;
      console.log("^^^^^^^^^^^^^^^^^^^^this.patientd", this.patientd)
      if (data[0].pre_followdate) {
        this.p_pre_followdate = data[0].pre_followdate;
      }
      if (data[0].pre_consult_date) {
        this.p_pre_consultdate = data[0].pre_consult_date;
      }
      this.p_address_1 = data[0].address_1;
      this.p_address_2 = data[0].address_2;
      this.p_city_n = data[0].city_n;
      this.p_contact_no = data[0].contact_no;
      this.p_dob = data[0].dob;
      this.p_email_id = data[0].email_id;
      this.p_first_name = data[0].first_name;
      this.p_gender = data[0].gender;
      this.p_last_name = data[0].last_name;
      this.p_ppurl = data[0].ppurl;
      this.p_state = data[0].state;
      this.p_zip = data[0].zip;
      this.since = data[0].apdate;
      //  this.dr_id = data[0].drid;
      this.allergy = data[0].allergy;
      this.p_purl = environment.content_base_url + "/" + this.p_ppurl;
      if (leng == 1) {
        this.apdate = null;
        this.followup_date = null;
      } else {
        this.apdate = data[leng - 2].apdate;
        this.followup_date = data[leng - 2].followup_date;
      }

      data.forEach((x, index) => {
        if (x.cid == this.cid) {
          this.reason = x.reason;
          this.aptime = x.aptime;
          this.endtime = x.endtime;
          this.aptdate = x.apdate;
          this.dr_id = x.drid;
          this.online_checkin = x.online_checkin;
          this.pid = x.pid;
        }
      });
      // this.reason = data[leng - 1].reason;
      // this.aptime = data[leng - 1].aptime;
      // this.endtime = data[leng - 1].endtime;
      // this.aptdate = data[leng - 1].apdate;

      //this.aptdate = data[leng - 1].apdate;

      // let stime = new Date("this.aptime");
      // let etime = new Date("this.endtime");
      // console.log("stimestimestime", stime);

      //this.consult_minutes = this.endtime - this.aptime;

      this.pids = data[0].pid;
      this.loadPatient(this.pids);
      this.getAppointment();
      this.fetchPreviousLabReports(this.pids, this.dr_id);
    });
  }

  goBack() {
    this.location.back();
  }

  statuscheck() {
    let flag = false;
    //Add an aditional condition online_checkin == Null for disable the INPERSON-ONLINE consultation
    if (this.online_checkin == false)
      this.saveDocuments();
    else
      if (flag == false && this.online_checkin == true) {
        let titlecontent;
        if (this.linksent == false)
          Swal.fire({
            title: "This is a online meeting, you have not created a meeting link,",
            text: "are you sure you want to continue?",
            type: "info",
            showCancelButton: true,
            buttonsStyling: true,
            confirmButtonClass: "btn btn-primary",
            confirmButtonText: "Yes",
            cancelButtonClass: "btn btn-secondary",
          }).then((result) => {
            if (result.value) {
              this.saveDocuments();
            }
          });
        else
          this.saveDocuments();
      }
  }

  // Save Statistics

  savestats() {
    var pid, cid, newreas;
    var today = new Date();
    var date = today.getDate();
    var month = today.getMonth() + 1;
    var year = today.getFullYear();
    var current_date = year + '-' + month + '-' + date;
    var oldreas = this.forms.reasonForm.value?.reasons;
    if (oldreas == "") {
      newreas = this.reason;

    } else {
      newreas = this.forms.reasonForm.value?.reasons;
    }

    let data = {
      ...this.forms.patstats.value,
      //...this.forms.reasonForm.value, 
      //in above code array key is 'reasons' now we want toc hange 'reason'
      //we can use like this instead of the above line
      reason: newreas,
      aid: parseInt(this.aid),

    };


    if (data.pat_stats && data.pat_stats.length === 0) {
      delete data.pat_stats;
    }

    if (data.pat_stats && data.pat_stats.length > 0) {
      //this.forms.reasonForm.value;
      var stats_std_val;
      data.pat_stats.forEach((x, index) => {
        x.stats_std_val = x.stats_value;
        x.aid = parseInt(this.cid);
        x.pid = parseInt(this.pids);
        x.stats_date_time = current_date;
        x.stats_by = this.drid;
        // if (x.stats_value == null) {
        //   delete x.stats_id;
        //   delete x.stats_value;
        //   delete x.stats_std_val;
        //   delete x.stats_date_time;
        //   delete x.pid;
        //   delete x.aid;
        // }
        delete x.stats_value;
      });
    }


    // const arr = data.pat_stats;
    // const results = arr.filter(element => {
    //   if (Object.keys(element).length !== 0) {
    //     return true;
    //   }
    //   return false;
    // });

    data.patient_checkin_stats = data.pat_stats;
    delete data.pat_stats;

    if (data.patient_checkin_stats && data.patient_checkin_stats.length === 0) {
      delete data.patient_checkin_stats;
    }
    this.checkin['chkinby'] = this.drid
    console.log("DATA", data);
    console.log("this.checkin", this.checkin)
    this.spinner.show();
    this.addPService.saveCheckin_stats(data).subscribe(
      () => {

        //
        this.checkinService.Checkin_s(this.route.snapshot.params['cid'], this.checkin).subscribe((result) => {
          this.router.navigate(["/appointments/Checkin"]);
          this.spinner.hide();
        }, (err) => {
          console.log(err);
        });

        //
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "success",
          title: "Check in Added Successfully !",
        });
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }



  getAppointment() {
    this.spinner.show();
    // this.reasonForm.value
    // this.pid = pid_id;
    this.service.getAppointmentDetails(
      {
        aid: this.aid, fields: ["documents"]
      }).subscribe(res => {
        this.spinner.hide();
        this.details = res;

        // display uploaded docs
        if (res && res.length > 0) {
          this.documents = this.forms.documentsForm.get(
            "documents"
          ) as UntypedFormArray;
          res.forEach(doc => {
            this.documents.push(this.createDocument(doc.description, doc.key.split('/').pop(), doc.type ? doc.type : "", doc.previewUrl, true));
          });
          if (this.documents.length < 10) {
            this.documents.push(this.createDocument());
          }
          if (this.documents.length > 10) {
            this.disableSubmit = true;
          }
        } else {
          this.addingDocument(1);
        }

      }, error => {
        this.spinner.hide();
        this.showToast('error', "Something went wrong. Please try again.");
      });
  }




  createDocument(description = "", name = "", type = "", previewUrl = "", readOnly = false): UntypedFormGroup {
    return this._formBuilder.group({
      description: [description, [Validators.required]],
      name: [name, [Validators.required]],
      type: [type],
      previewUrl: [previewUrl],
      readOnly: [readOnly]
    });
  }


  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  public addingDocument(i: number): void {

    if (this.documents && this.documents.length >= 10) {
      this.showToast('error', "Maximum 10 documents can be uploaded");
      return;
    }
    this.documents = this.forms.documentsForm.get(
      "documents"
    ) as UntypedFormArray;

    this.documents.push(this.createDocument());
  }






  async selectFile(event, i) {
    // 1. Find the file Extension Starts

    const isSeparator = (value: string): boolean => value === '/' || value === '\\' || value === ':';

    const getExtension = (path: string): string => {
      for (let i = path.length - 1; i > -1; --i) {
        const value = path[i];
        if (value === '.') {
          if (i > 1) {
            if (isSeparator(path[i - 1])) {
              return '';
            }
            return path.substring(i + 1);
          }
          return '';
        }
        if (isSeparator(value)) {
          return '';
        }
      }
      return '';
    };
    // Find the file Extension Ends

    let { target: { files } } = event;
    let [file] = files;
    // let data = { u_id: this.data.drid.toString(), };
    if (file) {
      let exten = getExtension(file.name);
      if (exten != "png" && exten != "jpeg" && exten != "jpg" && exten != "pdf") {
        // if (file.type != "image/png" && file.type != "image/jpeg" && file.type != "image/jpg" && file.type != "application/pdf") {

        this.showToast("error", "png, jpeg, jpg, PDF files only allowed");
        event.srcElement.value = null;
        return;
      }
      file.type
      if (file.size > this.maxSize) {
        this.showToast('error', "File exceeds 2MB");
        event.srcElement.value = null;
        return;
      }
      if (this.uploadedFiles && i < this.uploadedFiles.length) {
        this.uploadedFiles[i] = file;
      } else if (this.uploadedFiles) {
        this.uploadedFiles.push(file);
      } else {
        this.uploadedFiles = [file];
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        let previewUrl = reader.result;


        console.log(exten);
        console.log(file.name);
        console.log(file.type);
        this.documents.at(i).patchValue({ name: file.name, type: file.type, previewUrl: previewUrl });
      }
    }
    else {

      this.documents.at(i).patchValue({ name: '', type: '', previewUrl: '' });
    }
  }



  public removingCurrentDocument(i: number): void {

    if (this.documents.length === 1) {
      this.inputFile.nativeElement.value = "";
      this.documents.reset();
    }
    else if (this.details.length + 1 === this.documents.length) {
      this.documents.removeAt(i);
      this.addingDocument(i);
    }
    else {
      this.documents.removeAt(i);
      if (this.uploadedFiles) this.uploadedFiles.splice(i, 1);
    }
  }


  // Preview document fetch function
  async previewDocuments(doc: any) {
    let uri = environment.content_base_url + "/" + doc;
    if (Utils.allowedImageFormats.includes(doc.split('.').pop())) {
      Swal.fire({
        imageUrl: doc,
        showConfirmButton: false,
        showCloseButton: true,
      })
    } else {

      this.pdfSrc1 = doc;
      console.log(this.pdfSrc1);
      const files = { name: doc.name, type: doc.type };
      this.pdfSrc = doc;

      this.modal.open(this.PDFModal, { size: 'lg', centered: true, backdrop: 'static' });

    }
    // }
  }
  // Preview Docs on round image
  imgSrc: string;

  onClick(event) {
    const imgElem = event.target;

    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;
    this.imgSrc = srcAttr.nodeValue;

    //console.log(event);
    // console.log(event.srcElement);
    // console.log(event.currentTarget);
    // console.log(srcAttr);
    // console.log(this.imgSrc);
  }
  previewDocument(i) {
    if (this.documents.at(i).value && this.documents.at(i).value.previewUrl && this.documents.at(i).value.previewUrl.length > 0) {
      if (this.documents.at(i).value.type && this.documents.at(i).value.type.length > 0 && this.documents.at(i).value.type.includes('/')) {
        let file = this.documents.at(i).value.type.split('/');
        if (file && file.length > 0) {
          let fileType = file[0];
          if (Utils.IMGFILE == fileType) {
            Swal.fire({
              imageUrl: this.documents.at(i).value.previewUrl,
              showConfirmButton: false,
              showCloseButton: true,
            })
          } else {
            this.pdfSrc = this.documents.at(i).value.previewUrl;
            // console.log("this.documents", this.documents)
            // console.log("i", i)
            // console.log("this.documents.at(i)", this.documents.at(i))
            // console.log("this.documents.at(i).value", this.documents.at(i).value)
            // console.log("previewUrl", this.documents.at(i).value.previewUrl)
            // console.log("this.pdfSrc", this.pdfSrc)
            this.modal.open(this.PDFModal, { size: 'lg', centered: true, backdrop: 'static' });
          }
        }
      }
    }
  }


  loadPatient(pids) {
    console.log("qqqqqqqwwwwwwwwwwwwwwwwwww", this.pids);
    console.log("qqqqqqqwwwwwwwwwwwwwwwwwww", this.aid);
    this.spinner.show();
    this.service.fetchPatientByAId(pids, this.aid).subscribe(
      (response) => {
        this.spinner.hide();
        if (response) {
          console.log("response", response)
          this.patient = response;

        }
      })
  }

  saveDocuments() {
    if (this.forms.documentsForm.valid) {
      // Swal.fire({
      //   title: 'On final submit, the documents cannot be removed',
      //   text: "Are you sure?",
      //   type: 'info',
      //   showCancelButton: true,
      //   buttonsStyling: true,
      //   confirmButtonClass: 'btn btn-primary',
      //   confirmButtonText: 'Yes',
      //   cancelButtonClass: 'btn btn-secondary'
      // }).then((result) => {
      //   if (!this.aid) {
      //     this.showToast('error', "Something wrong. Couldn't schedule appointment!");
      //   }
      //   if (result.value) {
      if (this.documents.value.length > 0) {
        let docs = [];
        this.documents.value.forEach(doc => {
          if (!doc.readOnly) {
            delete doc.previewUrl;
            delete doc.readOnly;
            docs.push(doc);
          }
        });
        // get signed url from backend to upload
        this.spinner.show();
        this.savestats();
        this.spinner.hide();
        this.spinner.show();
        this.service.uploadDocs({
          pid: this.pids, aid: this.aid,
          documents: docs
        }, this.uploadedFiles).subscribe(res => {
          // const Toast = Swal.mixin({
          //   toast: true,
          //   position: "top",
          //   showConfirmButton: false,
          //   timer: 3000,
          // });
          // Toast.fire({
          //   type: "success",
          //   title: "Documents uploaded !",
          // });
          // this.showToast('success', 'Documents uploaded !');
          this.spinner.hide();
          // window.location.reload();
        }, error => {
          this.spinner.hide();
          this.showToast('error', 'Error in uploading documents. Please try again !')
        })
      }
    }
    // }
    // )
    // }
    else {
      let fil = this.forms.documentsForm.value.documents
      fil.forEach(doc => {
        if (doc.description === "" && doc.name === "") {
          this.savestats();
        }
        else {
          this.showToast('error', 'Error in uploading documents. Please try again  !')
        }

      });
    }
  }
  closeModal() {
    this.modal.dismissAll();
  }

}
